import { UserStatus } from '../models/User';

const translateUserStatus = (status: UserStatus) => {
  switch (status) {
    case UserStatus.Active:
      return 'Aktywny';
    case UserStatus.Inactive:
      return 'Nieaktywny';
    default:
      return status;
  }
};

export default translateUserStatus;
